/**
 * @generated SignedSource<<01437c8e023b83583b4baf817d22e1f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReissuePasswordMutationInput = {
  clientMutationId?: string | null;
  email: string;
};
export type AuthSnsSignupReissueMutation$variables = {
  input: ReissuePasswordMutationInput;
};
export type AuthSnsSignupReissueMutation$data = {
  readonly reissuePassword: {
    readonly email: string;
  };
};
export type AuthSnsSignupReissueMutation = {
  response: AuthSnsSignupReissueMutation$data;
  variables: AuthSnsSignupReissueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthSnsSignupReissueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReissuePasswordMutationPayload",
        "kind": "LinkedField",
        "name": "reissuePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthSnsSignupReissueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReissuePasswordMutationPayload",
        "kind": "LinkedField",
        "name": "reissuePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cfbd9630066835e216bb7ee183d5eba5",
    "id": null,
    "metadata": {},
    "name": "AuthSnsSignupReissueMutation",
    "operationKind": "mutation",
    "text": "mutation AuthSnsSignupReissueMutation(\n  $input: ReissuePasswordMutationInput!\n) {\n  reissuePassword(input: $input) {\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e7871b667734e0567c0eacd8042df66";

export default node;
